import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function GuaranteeSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-white relative border-y border-brand-gold/10" data-id="element-236" data-mp="9tbcar65iefn">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-237" data-mp="euh6yujdgbrt">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-238" data-mp="jt2ab2tx7bkh">
          <div className="w-20 h-20 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8" data-id="element-239" data-mp="xivx7flv7lrk">
            <ShieldCheck className="w-10 h-10 text-brand-gold" data-id="element-240" data-mp="12klcx8k18nlz" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-241" data-mp="17j69my02sp5o">
            {t('guarantee.title')}
          </h2>

          <div className="space-y-6 text-lg text-brand-charcoal max-w-2xl mx-auto" data-id="element-242" data-mp="25pki5klzj99s">
            <p data-id="element-243" data-mp="20rj0n447ji0f">{t('guarantee.p1')}</p>
            <p className="font-medium text-xl text-brand-brown" data-id="element-244" data-mp="1vthgefv1pcnd">
              {t('guarantee.p2')}
            </p>
            <p data-id="element-245" data-mp="1rsxktgq4eh3c">{t('guarantee.p3')}</p>
            <div className="bg-brand-cream p-6 rounded-sm border border-brand-gold/20 mt-8" data-id="element-246" data-mp="1rtyx1oivh9mn">
              <p className="italic" data-id="element-247" data-mp="2ohwvt3i39wz8">{t('guarantee.p4')}</p>
              <p className="font-bold text-brand-gold mt-2 uppercase tracking-widest text-sm" data-id="element-248" data-mp="2jitpzguabmq7">
                {t('guarantee.p5')}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}